import { Button, Input, Spin, Form, notification } from 'antd'
import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { LoadingOutlined } from '@ant-design/icons';
const addToCartRequest = require("./constants/addToCart.json");
const revalDoneReq = require("./constants/revalDoneReq.json");
const updateEmailAndUrlReq = require("./constants/emailAndUrl.json");
const paxDetails = require("./constants/paxDetails.json");
const baseUrl = "https://utdwia94zf.execute-api.us-east-1.amazonaws.com/beta"
const paymentDetailsReq = require("./constants/paymentDetailsUpdated.json")
const paymentHandlerReq = require("./constants/paymentHandler.json")
let config = {
    method: 'post',
    maxBodyLength: Infinity,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.QfxMTN0ATN0EzNzkTNyojIwhXZiwSMzUDNwUDNxcTM6ICdhlmIsIiZycDZ1cTL1ADOh1iYzMDNtQmY2UTLjRWYmdTNzImI6ISZk92YiwiIulWbkFGaj5WYyJmI6ISZtFmbyV2c1JCLiITZwlHdiojIlR2bDVGc5RlclNXdiwiI3MjNjBDZtQjZwkTLmlDN00iY3UWOtQzYmdjYmNGZiojIlR2bDRnbllGbjJCLiIjMhFjYh1CZxIDOtU2MjRTL2IGZ40iNyYTOxYmNiJiOiUGZvNEaj5WYyJmIsITMxojIklmIsUWdyRnOi4WZr9GVzV0cpJyef**off.C4k9FJtRKmsgIJ8wfn9xUWQVdZv1Sa60qtn9Y_HvSYQ'
    },
};


const S2B = () => {

    const [code, setCode] = useState(undefined)
    const [packageId, setPackageId] = useState(undefined)
    const [loading, setLoading] = useState(false)
    const [insiteJSON, setInsiteJSON] = useState(undefined);
    const [idOper, setIdOper] = useState(undefined);
    const [token, setToken] = useState('');
    const [errorCode, setErrorCode] = useState('');
    const [isFormInitialized, setIsFormInitialized] = useState(false);
    const [threeDSLoading, setThreeDSLoading] = useState(false)
    const [acceptPayment, setAcceptPayment] = useState(false)

    const generateOrderID = () => {
        const getRandomChar = () => {
            const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            return chars.charAt(Math.floor(Math.random() * chars.length));
        };
        let firstFourDigits = '';
        for (let i = 0; i < 4; i++) {
            firstFourDigits += Math.floor(Math.random() * 10);
        }
        let remainingChars = '';
        for (let i = 0; i < 8; i++) {
            remainingChars += getRandomChar();
        }
        return firstFourDigits + remainingChars;
    };

    const handleSubmit = async (idOper) => {
        if (threeDSLoading === false) {
            setThreeDSLoading(true);

            let orderId = localStorage.getItem("orderId")
            paymentHandlerReq.code = code
            paymentHandlerReq.packageId = packageId
            paymentHandlerReq.idOper = idOper;
            paymentHandlerReq.orderId = orderId;
            paymentHandlerReq.merchantCode = '036135358';

            config.data = JSON.stringify(paymentHandlerReq);
            config.url = baseUrl + '/k/agRequest/updateCart'

            let response = await axios.request(config)
            localStorage.setItem("paymentResponse", JSON.stringify(response.data.data))
            await handle3des(response.data.data)
        }
    }

    const handleChallengeAuthentication = async (threeDSServerTransId, acsTransId) => {
        let data = JSON.stringify({ threeDSServerTransId, acsTransId });
        console.log(data)
        config.url = baseUrl + '/c/payment/santanderChallengeExecution';
        config.data = data
        let response = await axios.request(config)
        if (response.data.success && response.data.data.paymentCompleted) {
            notification.success({ message: "Payment Successful" });
        } else {
            notification.error({ message: "Payment Failed" });
        }
        config.url = baseUrl + "/k/agRequest/updateCart";
        config.data = JSON.stringify({ "code": code, "cartStatus": "VALIDATE-PAYMENT" })
        const res = await axios.request(config);
        if (res.data.success) {
            notification.success({ message: "Validation Successful" });
        } else {
            notification.failure({ message: "Validation Failed" })
        }

    }

    const pollForAuthenticationStatus = async (threeDSServerTransID, acsTransID) => {
        try {

            const checkChallengeAuthorizationStatus = async (threeDSServerTransID, acsTransId) => {
                try {
                    let data = JSON.stringify({ threeDESTransId: threeDSServerTransID, acsTransId });
                    config.url = baseUrl + '/c/payment/santanderAuthorisationStatus';
                    config.data = data;
                    let response = await axios.request(config)
                    return response.data.success
                } catch (error) {
                    console.error(JSON.stringify(error));
                }
            }
            let isAuthorized = false
            while (isAuthorized === false) {
                isAuthorized = await checkChallengeAuthorizationStatus(threeDSServerTransID, acsTransID);
                if (isAuthorized) break;
            }
            if (isAuthorized) {
                handleChallengeAuthentication(threeDSServerTransID, acsTransID)
                    .then(() => { setThreeDSLoading(false); });
            }
        } catch (error) {
            console.error('Error in pollForAuthorizationStatus:', error);
        }
    };

    const handleChallengeRequest = async (data) => {
        try {
            const { acsUrl, creq } = data;
            let creqDecoded = JSON.parse(atob(creq));
            const threeDSServerTransID = creqDecoded.threeDSServerTransID
            const acsTransID = creqDecoded.acsTransID

            // Step 1: Create and append an iframe to the current page
            const iframe = document.createElement('iframe');
            iframe.width = '100%';
            iframe.height = '600px'; // Adjust height as needed
            iframe.style.border = 'none'; // Remove iframe border
            iframe.id = 'auth'

            document.body.appendChild(iframe); // Append iframe to the body of the current page

            // Step 2: Access the iframe's document
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

            // Step 3: Create a form dynamically within the iframe
            const form = iframeDoc.createElement('form');
            form.action = acsUrl; // The 3DS Method URL
            form.method = 'POST';
            // form.enctype = "application/x-www-form-urlencoded"

            form.target = '_self'; // Ensure form submission is handled within the iframe

            // Add necessary form fields
            const input = iframeDoc.createElement('input');
            input.type = 'hidden'; // Hidden input field
            input.name = 'creq';
            input.value = creq;
            form.appendChild(input);

            // Append the form to the iframe document
            iframeDoc.body.appendChild(form);
            let count = 0;
            iframe.addEventListener('load', () => {
                // Alert once the iframe content has loaded
                count++
                setThreeDSLoading(false)
                if (count === 2) {
                    let authForm = document.getElementById('auth')
                    authForm.style.display = 'none'
                    pollForAuthenticationStatus(threeDSServerTransID, acsTransID).then(res => {
                        if (res) {
                            notification.success({ message: "Payment Successful" });
                        }
                    })
                }

            });


            // Step 4: Submit the form automatically
            form.submit();
        } catch (error) {
            console.error("Error in handleChallengeRequest:", error);
        }
    };

    const handle3desAuthentication = async (threeDSCompInd) => {
        try {
            setThreeDSLoading(true);
            const paymentResponse = JSON.parse(localStorage.getItem("paymentResponse"));
            const authRequest = {
                code: paymentResponse?.verificationCode,
                browserUserAgent: navigator.userAgent,
                browserJavaEnabled: navigator.javaEnabled().toString(),
                browserLanguage: navigator.language,
                browserColorDepth: window.screen.colorDepth.toString(),
                browserScreenHeight: window.screen.height.toString(),
                browserScreenWidth: window.screen.width.toString(),
                browserTZ: (-new Date().getTimezoneOffset() / 60).toString(),
                threeDSCompInd
            };
            config.url = baseUrl + "/c/payment/santanderAuthorisation";
            config.data = JSON.stringify(authRequest);
            const response = await axios.request(config);
            if (response.data.success) {
                if (response?.data?.data?.acsUrl) {
                    await handleChallengeRequest(response.data.data)
                } else {
                    if (response.data.data.paymentCompleted) {
                        notification.success({ message: "Payment Successful" });
                    } else {
                        notification.failure({ message: "Payment Failed" });
                    }
                    config.url = baseUrl + "/k/agRequest/updateCart";
                    config.data = JSON.stringify({ "code": code, "cartStatus": "VALIDATE-PAYMENT" })
                    const res = await axios.request(config);
                    if (res.data.success) {
                        notification.success({ message: "Validation Successful" });
                    } else {
                        notification.failure({ message: "Validation Failed" })
                    }
                    setThreeDSLoading(false);
                }
            } else {
                setThreeDSLoading(false);
                notification.error({ message: "Payment Failed" });
            }
            setThreeDSLoading(false);
        } catch (error) {
            console.error("Error in handle 3des Authentication:", error);
            setThreeDSLoading(false);
            return false;
        }
    };

    const pollFor3desAuthorizationStatus = async (threeDSServerTransID) => {
        try {
            const check3desAuthorizationStatus = async (threeDSServerTransID) => {
                try {
                    let data = JSON.stringify({ "code": threeDSServerTransID });
                    config.url = baseUrl + '/c/payment/santanderPaymentStatus';
                    config.data = data
                    let response = await axios.request(config)
                    return response.data.success
                } catch (error) {
                    console.error(JSON.stringify(error));
                }
            }

            let isAuthorized = false
            while (isAuthorized === false) {
                isAuthorized = await check3desAuthorizationStatus(threeDSServerTransID);
                if (isAuthorized) break;
            }
            if (isAuthorized) {
                handle3desAuthentication(isAuthorized ? "Y" : "N").then(res => {
                    if (res) setThreeDSLoading(false);
                });
            }
        } catch (error) {
            console.error('Error in pollForAuthorizationStatus:', error);
        }
    };

    const executeThreeDSMethod = async (threeDSMethodURL, threeDSServerTransID) => {
        try {
            // Step 1: Create and append an iframe to the current page
            const iframe = document.createElement('iframe');
            iframe.width = '100%';
            iframe.height = '600px'; // Adjust height as needed
            iframe.style.border = 'none';
            iframe.style.display = 'none';
            iframe.sandbox = "allow-scripts allow-same-origin allow-forms"; // Allow scripting, same-origin policy, and form submissions
            document.body.appendChild(iframe); // Append iframe to the body of the current page

            // Step 2: Access the iframe's document
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

            // Step 3: Create a form dynamically within the iframe
            const form = iframeDoc.createElement('form');
            form.action = threeDSMethodURL; // The 3DS Method URL
            form.method = 'POST';

            // Add necessary form fields
            const input = iframeDoc.createElement('input');
            input.type = 'hidden'; // Hidden input field
            input.name = 'threeDSMethodData';
            input.value = btoa(
                JSON.stringify({
                    threeDSServerTransID,
                    threeDSMethodNotificationURL: `${baseUrl}/c/payment/santanderRedirectPayment`
                })
            );
            form.appendChild(input);

            // Append the form to the iframe document
            iframeDoc.body.appendChild(form);

            // Step 4: Submit the form automatically
            let count = 0;
            iframe.addEventListener('load', () => {
                // Alert once the iframe content has loaded
                setThreeDSLoading(false);
                count++
                console.log(count)
                if (count === 2) pollFor3desAuthorizationStatus(threeDSServerTransID);
            });
            form.submit();

        } catch (error) {
            console.error('Error executing 3DS Method:', error);
        }
    };

    const handle3des = async (paymentResponse) => {
        let cartForm = document.getElementById('card')
        cartForm.style.display = 'none'
        const verificationCode = paymentResponse.verificationCode
        const redirectURL = paymentResponse.redirectURL
        if (redirectURL) {
            executeThreeDSMethod(redirectURL, verificationCode);
        } else {
            handle3desAuthentication("N").then(res => { if (res) setThreeDSLoading(false); });
        }
    };

    useEffect(() => {
        const scriptId = 'redsys-script';
        // Check if the script is already added to avoid adding it again
        if (insiteJSON) {
            if (!document.getElementById(scriptId)) {
                const script = document.createElement('script');
                script.src = 'https://sis-t.redsys.es:25443/sis/NC/sandbox/redsysV3.js';
                script.async = true;
                script.id = scriptId; // Assign an ID to prevent duplication

                script.onload = () => {
                    if (window.getInSiteFormJSON && !isFormInitialized) {
                        window.getInSiteFormJSON(insiteJSON);
                        setIsFormInitialized(true);
                    }
                };

                document.body.appendChild(script);
            } else {
                // If the script already exists, directly initialize the form
                if (window.getInSiteFormJSON && !isFormInitialized) {
                    window.getInSiteFormJSON(insiteJSON);
                    setIsFormInitialized(true);
                }
            }
        }


    }, [insiteJSON, isFormInitialized]);

    useEffect(() => {
        if (acceptPayment) {
            let orderId = generateOrderID()
            let data = {
                id: 'card-form', fuc: '036135358', terminal: '001', order: orderId, estiloInsite: 'inline',
                idiomaInsite: 'IN', buttonValue: "Proceed to Pay", idioma: 'IN', mostrarLogo: true,
            }
            localStorage.setItem("orderId", orderId)
            setInsiteJSON(data)

            const receiveMessage = async (event) => {
                if (window.storeIdOper && typeof window.storeIdOper === 'function') {
                    await window.storeIdOper(event, 'token', 'errorCode');
                    setToken(document.getElementById('token')?.value || '');
                    setErrorCode(document.getElementById('errorCode')?.value || '');
                } else {
                    console.warn("storeIdOper function is not available.");
                }

                if (event.data && event.data.idOper) {
                    setIdOper(event.data.idOper);
                    localStorage.setItem("idOper", event.data.idOper)
                    handleSubmit(event.data.idOper)
                } else {
                    console.warn("Unexpected event data format:", event.data);
                }
            };

            window.addEventListener('message', receiveMessage);

            return () => {
                window.removeEventListener('message', receiveMessage);
            };
        }
    }, [acceptPayment]);

    const updatePaymentDetails = async (code, packageId) => {
        try {
            paymentDetailsReq.code = code
            config.data = JSON.stringify(paymentDetailsReq)
            config.url = baseUrl + '/k/agRequest/updateCart'
            await axios.request(config)
            setAcceptPayment(true)
            setLoading(false)
            // await paymentHandler(code, packageId)
        } catch (error) {
            console.error(JSON.stringify(error));
            return { success: false, message: error }
        }
    }

    const validateCart = async (code, packageId) => {
        try {
            config.data = JSON.stringify({
                "code": code,
                "cartStatus": "VALIDATE-CART"
            });
            config.url = baseUrl + '/k/agRequest/updateCart'
            await axios.request(config)
            await updatePaymentDetails(code, packageId)
        } catch (error) {
            console.error(JSON.stringify(error));
            return { success: false, message: error }
        }
    }

    const updatePaxDetails = async (code, packageId) => {
        try {
            paxDetails.code = code
            config.data = JSON.stringify(paxDetails)
            config.url = baseUrl + '/k/agRequest/updateCart'
            await axios.request(config)
            await validateCart(code, packageId)
        } catch (error) {
            console.error(JSON.stringify(error));
            return { success: false, message: error }
        }
    }

    const updateEmailAndUrl = async (code, packageId) => {
        try {
            updateEmailAndUrlReq.code = code
            config.data = JSON.stringify(updateEmailAndUrlReq)
            config.url = baseUrl + '/k/agRequest/updateCart'
            await axios.request(config)
            await updatePaxDetails(code, packageId)
        } catch (error) {
            console.error(JSON.stringify(error));
            return { success: false, message: error }
        }
    }

    const addRevalJson = async (code, packageId) => {
        try {
            revalDoneReq.code = code
            config.data = JSON.stringify(revalDoneReq)
            config.url = baseUrl + '/k/agRequest/updateCart'
            await axios.request(config)
            await updateEmailAndUrl(code, packageId)
        } catch (error) {
            console.error(JSON.stringify(error));
            return { success: false, message: error }
        }
    }

    const addToCart = async () => {
        localStorage.clear()
        setLoading(true)
        config.data = JSON.stringify(addToCartRequest);
        config.url = baseUrl + '/k/agRequest/addToCart'
        let response = await axios.request(config)
        setCode(response.data.data.code)
        setPackageId(response.data.data.packageId)
        await addRevalJson(response.data.data.code, response.data.data.packageId)
    }


    return (
        <div style={{ textTransform: "capitalize" }}>
            <div style={{ textAlign: "center" }}>
                <h1 style={{ color: "black" }}>Santander Payment Gateway</h1>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <table>
                        <thead>
                            <th>Description</th>
                            <th>Card No</th>
                        </thead>
                        <tbody>
                            <tr>
                                <th>  Frictionless Authentication · EMV3DS 2.1 with threeDSMethodURL.</th>
                                <td>4918019160034602</td>
                            </tr>
                            <tr>
                                <th>  Frictionless Authentication · EMV3DS 2.1 without threeDSMethodURL</th>
                                <td>4548814479727229</td>
                            </tr>
                            <tr>
                                <th>  Authentication Challenge · EMV3DS 2.1 with threeDSMethodURL</th>
                                <td>4918019199883839</td>
                            </tr>
                            <tr>
                                <th> Authentication Challenge · EMV3DS 2.1 without threeDSMethodURL</th>
                                <td>4548817212493017</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {loading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /> : ""}
                {code && <p>Code: {code}</p>}
                {packageId && <p>PackageId: {packageId}</p>}

                <Button type="primary" size='large' onClick={() => { addToCart() }}>Search</Button>

                {threeDSLoading
                    && <Spin tip="Loading..." fullscreen indicator={<LoadingOutlined style={{ fontSize: 64 }} spin />} />}
                <div style={{ height: "90vh" }} id="card" >
                    <div id="card-form" style={{ height: "25rem", padding: "5rem" }} />
                    <Form name="datos">
                        <Form.Item>
                            <Input type="hidden" id="token" value={token} />
                        </Form.Item>
                        <Form.Item>
                            <Input type="hidden" id="errorCode" value={errorCode} />
                        </Form.Item>
                        <Form.Item>
                            <Input type="hidden" id="idOper" value={idOper} />
                        </Form.Item>
                    </Form>
                </div >
            </div>

        </div>
    )
}

export default S2B